"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var slate_1 = require("slate");
var core_1 = require("@21st-night/core");
var slate_react_1 = require("slate-react");
var CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            position: 'relative',
            marginBottom: theme.spacing(2),
            textAlign: 'center',
        },
        image: {
            maxWidth: '100%',
        },
        progressContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            backgroundColor: 'rgba(96, 125, 139, 0.3)',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        },
    });
});
var EditorUploadImage = function (_a) {
    var attributes = _a.attributes, children = _a.children, fileProp = _a.file, element = _a.element;
    var classes = exports.useStyles();
    var _b = core_1.useUploads(), addUpload = _b.addUpload, removeUpload = _b.removeUpload;
    var storage = core_1.useFirebase().storage;
    var editor = slate_react_1.useEditor();
    var _c = __read(react_1.useState(fileProp), 1), file = _c[0];
    var _d = __read(react_1.useState(''), 2), src = _d[0], setSrc = _d[1];
    var _e = __read(react_1.useState(new FileReader()), 1), reader = _e[0];
    var _f = __read(react_1.useState(new Image()), 1), image = _f[0];
    var path = slate_react_1.ReactEditor.findPath(editor, element);
    function onUploadSuccess(url, id) {
        removeUpload(id);
        slate_1.Transforms.setNodes(editor, {
            type: 'image-uploaded',
            cropped: false,
            id: id,
            url: url,
        }, { at: path });
    }
    var _g = core_1.useFileUpload(storage, {
        onUploadSuccess: onUploadSuccess,
    }), upload = _g.upload, progress = _g.progress, fileId = _g.id;
    reader.onload = function (event) {
        setSrc(event.target.result);
    };
    image.onload = function () {
        slate_1.Transforms.setNodes(editor, {
            dimensions: {
                height: image.height,
                width: image.width,
                aspectRatio: image.width / image.height || 1,
            },
        }, { at: path });
    };
    react_1.useEffect(function () {
        addUpload(fileId);
        upload(file);
        reader.readAsDataURL(file);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [file]);
    react_1.useEffect(function () {
        image.src = src;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [src]);
    return (react_1.default.createElement("div", __assign({ className: classes.root }, attributes),
        react_1.default.createElement("div", { contentEditable: false },
            src && react_1.default.createElement("img", { className: classes.image, src: src, alt: "" }),
            react_1.default.createElement("div", { className: classes.progressContainer },
                react_1.default.createElement(CircularProgress_1.default, { variant: "static", size: 30, value: progress }))),
        react_1.default.createElement("div", null, children)));
};
exports.default = EditorUploadImage;
//# sourceMappingURL=EditorUploadImage.js.map